module.exports = __webpack_public_path__ + "3ea520389909d30789d6991f21bf32ce.MP3";